import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Spin, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";

import "./Categories.scss";
import { PAGE_SIZE } from "../../constants";
import MobileVersionForm from "../Forms/MobileVersion";
import {
	createMobileVersion,
	fetchMobileVersions,
	updateMobileVersion,
	deleteMobileVersion,
} from "../../actions/mobileVersion";
import MobileVersionsTable from "../Tables/MobileVersions";

const MobileVersionsPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [mobileVersionId, setMobileVersionId] = useState(null);
	const { mobileVersions, loading } = useSelector(
		(state) => state.fetchMobileVersions,
	);
	const { mobileVersionUpdated } = useSelector(
		(state) => state.updateMobileVersion,
	);
	const { mobileVersionDeleted } = useSelector(
		(state) => state.deleteMobileVersion,
	);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;

	useEffect(() => {
		dispatch(fetchMobileVersions({ start: 0, count: PAGE_SIZE }));
	}, []);

	useEffect(() => {
		dispatch(fetchMobileVersions({ start: 0, count: PAGE_SIZE }));
	}, [mobileVersionUpdated, mobileVersionDeleted]);

	useEffect(() => {
		if (mobileVersions) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: mobileVersions.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [mobileVersions]);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleAddNew = () => {
		showModal();
		setMobileVersionId(null);
		form.resetFields();
	};

	const handleEdit = (record) => {
		showModal();
		setMobileVersionId(record.id);
		form.setFieldsValue(record);
	};

	const handleClickDelete = (record) => {
		dispatch(deleteMobileVersion(record.id));
	};

	const handleSubmitForm = (values) => {
		if (mobileVersionId) {
			dispatch(updateMobileVersion(mobileVersionId, values));
		} else {
			dispatch(createMobileVersion(values));
		}
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</span>
		);
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchMobileVersions({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="mobile-versions-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Survey Categories</li>
						</ul>
					</div>
					<div className="page-header-actions">
						<Button
							type="primary"
							className="btn btn-primary"
							onClick={handleAddNew}
						>
							New Mobile Versions
							<ReactSVG src="/icons/post-add.svg" />
						</Button>
					</div>
				</div>
				<div className="page-content">
					{mobileVersions && (
						<MobileVersionsTable
							rowKey="id"
							dataSource={mobileVersions.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={100}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="add-mobile-version-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					<MobileVersionForm
						form={form}
						mobileVersionId={mobileVersionId}
						handleOk={handleOk}
						handleSubmitForm={handleSubmitForm}
						handleCancel={handleCancel}
					/>
				</Modal>
			</div>
		</Spin>
	);
};

export default MobileVersionsPage;
